/**
 *
 * DisagreementDialogContainer
 *
 */

import React from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import injectReducer from 'utils/injectReducer';
import injectSaga from 'utils/injectSaga';

import reducer from './reducer';
import saga from './sagas';

import { DIALOG_NAME } from './constants';
import * as actionCreators from './actions';
import DisagreementDialog from './DisagreementDialog';
import { makeSelectIsOpen, makeSelectRowIds, makeSelectDxGrid } from './selectors';

class DisagreementDialogContainer extends React.PureComponent { // eslint-disable-line react/prefer-stateless-function
  handleSubmit = (ids, comment, dxGrid) => this.props.submit(ids, comment, dxGrid);

  handleCancel = () => this.props.close();

  render() {
    const {
      ids,
      open,
      dxGrid,
    } = this.props;

    return (
      <DisagreementDialog
        ids={ids}
        onCancel={this.handleCancel}
        onSubmit={this.handleSubmit}
        open={open}
        dxGrid={dxGrid}
      />
    );
  }
}

DisagreementDialogContainer.propTypes = {
  close: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  submit: PropTypes.func.isRequired,
  ids: PropTypes.arrayOf(
    PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number,
    ]),
  ),
};

const mapStateToProps = createStructuredSelector({
  open: makeSelectIsOpen(),
  ids: makeSelectRowIds(),
  dxGrid: makeSelectDxGrid(),
});

function mapDispatchToProps(dispatch) {
  return {
    submit: (ids, comment, dxGrid) => dispatch(actionCreators.submitDisagreementDialog(ids, comment, dxGrid)),
    close: () => dispatch(actionCreators.closeDisagreementDialog()),
  };
}

const withReducer = injectReducer({ key: DIALOG_NAME, reducer });
const withSaga = injectSaga({ key: DIALOG_NAME, saga });
const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(
  withReducer,
  withSaga,
  withConnect,
)(DisagreementDialogContainer);
